import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import NumberInputTextValue from 'assets/components/inputs/number/NumberInputTextValue';
import { getLocales } from 'assets/locales/Locale';
import ProductType from 'models/enums/ProductType';
import { Fragment } from 'react';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import {
  CustomSelection,
  NonWarrantySelection,
  WarrantyClassBased,
  WarrantyTierBased,
} from '../../newContract/sections/Sales.NewContract.Contract';
import { useSalesQuoteProvider } from '../Sales.Quote.Hooks';

export default function SalesNewContractContract() {
  const { lang } = getLocales();
  const { form, updateProduct, productWithPrices } = useSalesQuoteProvider();

  return (
    <DataMap
      data={form.data.products}
      render={({ data: product, isFirst }) => {
        const prices = productWithPrices.find((pp) => pp.product.id === product.id);

        return (
          <Fragment key={product.id}>
            <FormWrapper>
              {!isFirst && <hr />}
              <h2 data-productid={product.id}>{product.name}</h2>
              {product.productType === ProductType.custom && form.data.dealer && (
                <CustomSelection
                  product={product}
                  updateProduct={updateProduct}
                  prices={prices.customPrices}
                  dealer={form.data.dealer}
                />
              )}
              {product.productType === ProductType.nonWarranty && form.data.dealer && (
                <NonWarrantySelection
                  product={product}
                  updateProduct={updateProduct}
                  prices={prices.nonWarrantyPrices}
                  dealer={form.data.dealer}
                />
              )}
              {product.productType === ProductType.warrantyTierBased && form.data.dealer && (
                <WarrantyTierBased
                  product={product}
                  updateProduct={updateProduct}
                  prices={prices.warrantyTierPrices}
                  dealer={form.data.dealer}
                />
              )}
              {product.productType === ProductType.warrantiClassBased && form.data.dealer && (
                <WarrantyClassBased
                  product={product}
                  updateProduct={updateProduct}
                  prices={prices.warrantyClassPrices}
                  dealer={form.data.dealer}
                  vehicle={form.data.vehicle}
                />
              )}
              <br />
              <br />
              <NumberInputTextValue
                name="total"
                label={lang.total}
                value={product?.priceCAD + (product.surchargesPriceCAD ?? 0) + (product.enhancementsPriceCAD ?? 0)}
                readOnly={true}
                onChange={() => {
                  updateProduct(product);
                }}
                icon={<Icon class="fas-dollar-sign" />}
              />
            </FormWrapper>
          </Fragment>
        );
      }}
    />
  );
}
